import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Vas from '../Vas';
import $ from 'jquery';
import '../css/RoleManagement.css';

import { ExtendedButton,Switcher,MessageBox,Panel,Loading } from "component-lib";
import { Right,CheckValues } from 'utils-lib';
import { RoleConfigurationModel, RequestAjaxClass } from 'models-lib';

let PupilCustomersRead;
let PupilCustomersCreate;
let PupilCustomersEdit;
let PupilCustomersDelete;

let PupilMyDataRead;
let PupilMyDataCreate;
let PupilMyDataEdit;
let PupilMyDataDelete;

let PupilContractsRead;
let PupilContractsCreate;
let PupilContractsEdit;
let PupilContractsDelete;

let PupilMyContractsRead;
let PupilMyContractsCreate;
let PupilMyContractsEdit;
let PupilMyContractsDelete;

let PupilAccountsRead;
let PupilAccountsCreate;
let PupilAccountsEdit;
let PupilAccountsDelete;

let PupilMyAccountRead;
let PupilMyAccountCreate;
let PupilMyAccountEdit;
let PupilMyAccountDelete;

let PupilFormsRead;
let PupilFormsCreate;
let PupilFormsEdit;
let PupilFormsDelete;

let SchoolCustomersRead;
let SchoolCustomersCreate;
let SchoolCustomersEdit;
let SchoolCustomersDelete;

let SchoolMyDataRead;
let SchoolMyDataCreate;
let SchoolMyDataEdit;
let SchoolMyDataDelete;

let SchoolContractsRead;
let SchoolContractsCreate;
let SchoolContractsEdit;
let SchoolContractsDelete;

let SchoolMyContractsRead;
let SchoolMyContractsCreate;
let SchoolMyContractsEdit;
let SchoolMyContractsDelete;

let SchoolAccountsRead;
let SchoolAccountsCreate;
let SchoolAccountsEdit;
let SchoolAccountsDelete;

let SchoolMyAccountRead;
let SchoolMyAccountCreate;
let SchoolMyAccountEdit;
let SchoolMyAccountDelete;

let SchoolFormsRead;
let SchoolFormsCreate;
let SchoolFormsEdit;
let SchoolFormsDelete;

class RoleManagement extends Component{

    constructor(props)
    {
        super(props);
        this.state = {};
        this.RoleConfig = new RoleConfigurationModel([this]);
        this.Request = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);
    }

    componentWillMount(){
        this.Request.setAuth(true);
        this.Request.setApiKey(Vas.ApiKey);
        this.Request.setApiUrl(Vas.ApiUrl);
        this.RoleConfig.SetRequest(this.Request);
        this.Request.setErrorHandler(()=>{
          ReactDOM.unmountComponentAtNode(document.getElementById('popupContainer'));
        });
        this.RoleConfig.GetRoleConfiguration(); 

        ReactDOM.render(<Loading modal={true} />,document.getElementById('popupContainer'));
    }

    componentDidMount(){
        $("#HeaderTitle").html(Vas.Resources.Labels["RoleManagement"]);
    }

    Update(observer){
      let me = this;
      this.setState({},()=>{
        if(observer === "RoleConfiguration"){
            let roles = me.RoleConfig.Configuration;
            /*let roles = [{"UserRole":1,"Configuration":'[{\"Description\":\"alleKunden\",\"Read\":true,\"Create\":true,\"Edit\":true,\"Delete\":true},{\"Description\":\"meineDaten\",\"Read\":true,\"Create\":false,\"Edit\":true,\"Delete\":false},{\"Description\":\"alleVerträge\",\"Read\":true,\"Create\":true,\"Edit\":true,\"Delete\":true},{\"Description\":\"meineVerträge\",\"Read\":false,\"Create\":false,\"Edit\":false,\"Delete\":false},{\"Description\":\"alleKonten\",\"Read\":true,\"Create\":true,\"Edit\":true,\"Delete\":true},{\"Description\":\"meinKonto\",\"Read\":true,\"Create\":false,\"Edit\":true,\"Delete\":false},{\"Description\":\"Formulare\",\"Read\":true,\"Create\":true,\"Edit\":true,\"Delete\":true}]'},
                          {"UserRole":2,"Configuration":'[{\"Description\":\"alleKunden\",\"Read\":true,\"Create\":false,\"Edit\":false,\"Delete\":false},{\"Description\":\"meineDaten\",\"Read\":true,\"Create\":true,\"Edit\":true,\"Delete\":true},{\"Description\":\"alleVerträge\",\"Read\":false,\"Create\":false,\"Edit\":false,\"Delete\":false},{\"Description\":\"meineVerträge\",\"Read\":true,\"Create\":true,\"Edit\":true,\"Delete\":true},{\"Description\":\"alleKonten\",\"Read\":false,\"Create\":false,\"Edit\":false,\"Delete\":false},{\"Description\":\"meinKonto\",\"Read\":true,\"Create\":false,\"Edit\":true,\"Delete\":false},{\"Description\":\"Formulare\",\"Read\":true,\"Create\":false,\"Edit\":false,\"Delete\":false}]'},
                          {"UserRole":3,"Configuration":'[{\"Description\":\"alleKunden\",\"Read\":true,\"Create\":false,\"Edit\":false,\"Delete\":false},{\"Description\":\"meineDaten\",\"Read\":true,\"Create\":true,\"Edit\":true,\"Delete\":true},{\"Description\":\"alleVerträge\",\"Read\":false,\"Create\":false,\"Edit\":false,\"Delete\":false},{\"Description\":\"meineVerträge\",\"Read\":true,\"Create\":true,\"Edit\":true,\"Delete\":true},{\"Description\":\"alleKonten\",\"Read\":false,\"Create\":false,\"Edit\":false,\"Delete\":false},{\"Description\":\"meinKonto\",\"Read\":true,\"Create\":false,\"Edit\":true,\"Delete\":false},{\"Description\":\"Formulare\",\"Read\":true,\"Create\":false,\"Edit\":false,\"Delete\":false}]'}];*/
            let rights1 = [];
            let rights2 = [];
            let rights3 = [];
            if (roles.length >= 3){
              for(let i = 0; i<roles.length; i++){
                if(roles[i].UserRole !== null && roles[i].UserRole !== undefined){
                  if(roles[i].Configuration !== null && roles[i].Configuration !== undefined){
                    if(CheckValues.CheckJSON(roles[i].Configuration) === true){
                      if(roles[i].UserRole === 1){
                        rights1 = JSON.parse(roles[i].Configuration);
                      }
                      if(roles[i].UserRole === 2){
                        rights2 = JSON.parse(roles[i].Configuration);
                      }
                      if(roles[i].UserRole === 3){
                        rights3 = JSON.parse(roles[i].Configuration);
                      }
                    }
                  }
                }
              }
              
              /*if(roles[1].Configuration !== null && roles[1].Configuration !== undefined){
                if(CheckValues.CheckJSON(roles[1].Configuration) === true){
                  rights2 = JSON.parse(roles[1].Configuration);  
                }
              }
              if(roles[2].Configuration !== null && roles[2].Configuration !== undefined){
                if(CheckValues.CheckJSON(roles[2].Configuration) === true){
                  rights3 = JSON.parse(roles[2].Configuration);  
                }
              }*/
            }
            roles = [rights1,rights2,rights3];
            ReactDOM.render(
              <table>
                <tbody>
                  <tr >
                    <td>
                      <Panel 
                        AppURL={Vas.ApplicationUrl} 
                        C={'c1'} 
                        HeaderIcon={"Settings"} 
                        Width={600} 
                        Height={'auto'} 
                        Header={Vas.Resources.Labels["Pupil"]} 
                        Id={"row1"} 
                        Drag={false} 
                        Content={
                          <div>
                            <table>
                              <thead>
                                <tr>
                                  <td style={{ "width":'100%' }}></td><td>{Vas.Resources.Labels["Read"]}</td><td>{Vas.Resources.Labels["Create"]}</td><td>{Vas.Resources.Labels["Edit"]}</td><td>{Vas.Resources.Labels["Delete"]}</td>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  id={1}
                                  title={"alleKunden"}>
                                  <td style={{ paddingTop: "20px" }}>{Vas.Resources.Labels["AllCustomers"]}</td>
                                  <td id={1}><Switcher
                                    Id={"PupilCustomersRead"}
                                    On={roles[0][0]?roles[0][0].Read?roles[0][0].Read:false:false}
                                    ref={inst => {PupilCustomersRead = inst;}}
                                    referenc={this} /></td>
                                  <td id={2}><Switcher
                                    Id={"PupilCustomersCreate"}
                                    On={roles[0][0]?roles[0][0].Create?roles[0][0].Create:false:false}
                                    ref={inst => {PupilCustomersCreate = inst;}}
                                    referenc={this} /></td>
                                  <td id={3}><Switcher
                                    Id={"PupilCustomersEdit"}
                                    On={roles[0][0]?roles[0][0].Edit?roles[0][0].Edit:false:false}
                                    ref={inst => {PupilCustomersEdit = inst;}}
                                    referenc={this} /></td>
                                  <td id={4}><Switcher
                                    Id={"PupilCustomersDelete"}
                                    On={roles[0][0]?roles[0][0].Delete?roles[0][0].Delete:false:false}
                                    ref={inst => {PupilCustomersDelete = inst;}}
                                    referenc={this} /></td>
                                </tr>
                                <tr
                                  id={2}
                                  title={"meineDaten"}>
                                  <td style={{ paddingTop: "20px" }}>{Vas.Resources.Labels["MyData"]}</td>
                                  <td id={1}><Switcher
                                    Id={"PupilMyDataRead"}
                                    On={roles[0][1]?roles[0][1].Read?roles[0][1].Read:false:false}
                                    ref={inst => {PupilMyDataRead = inst;}}
                                    referenc={this} /></td>
                                  <td id={2}><Switcher
                                    Id={"PupilMyDataCreate"}
                                    On={roles[0][1]?roles[0][1].Create?roles[0][1].Create:false:false}
                                    ref={inst => {PupilMyDataCreate = inst;}}
                                    referenc={this} /></td>
                                  <td id={3}><Switcher
                                    Id={"PupilMyDataEdit"}
                                    On={roles[0][1]?roles[0][1].Edit?roles[0][1].Edit:false:false}
                                    ref={inst => {PupilMyDataEdit = inst;}}
                                    referenc={this} /></td>
                                  <td id={4}><Switcher
                                    Id={"PupilMyDataDelete"}
                                    On={roles[0][1]?roles[0][1].Delete?roles[0][1].Delete:false:false}
                                    ref={inst => {PupilMyDataDelete = inst;}}
                                    referenc={this} /></td>
                                </tr>
                                <tr
                                  id={3}
                                  title={"alleVerträge"}>
                                  <td style={{ paddingTop: "20px" }}>{Vas.Resources.Labels["AllContracts"]}</td>
                                  <td id={1}><Switcher
                                    Id={"PupilContractsRead"}
                                    On={roles[0][2]?roles[0][2].Read?roles[0][2].Read:false:false}
                                    ref={inst => {PupilContractsRead = inst;}}
                                    referenc={this} /></td>
                                  <td id={2}><Switcher
                                    Id={"PupilContractsCreate"}
                                    On={roles[0][2]?roles[0][2].Create?roles[0][2].Create:false:false}
                                    ref={inst => {PupilContractsCreate = inst;}}
                                    referenc={this} /></td>
                                  <td id={3}><Switcher
                                    Id={"PupilContractsEdit"}
                                    On={roles[0][2]?roles[0][2].Edit?roles[0][2].Edit:false:false}
                                    ref={inst => {PupilContractsEdit = inst;}}
                                    referenc={this} /></td>
                                  <td id={4}><Switcher
                                    Id={"PupilContractsDelete"}
                                    On={roles[0][2]?roles[0][2].Delete?roles[0][2].Delete:false:false}
                                    ref={inst => {PupilContractsDelete = inst;}}
                                    referenc={this} /></td>
                                </tr>
                                <tr
                                  id={4}
                                  title={"meineVerträge"}>
                                  <td style={{ paddingTop: "20px" }}>{Vas.Resources.Labels["MyContracts"]}</td>
                                  <td id={1}><Switcher
                                    Id={"PupilMyContractsRead"}
                                    On={roles[0][3]?roles[0][3].Read?roles[0][3].Read:false:false}
                                    ref={inst => {PupilMyContractsRead = inst;}}
                                    referenc={this} /></td>
                                  <td id={2}><Switcher
                                    Id={"PupilMyContractsCreate"}
                                    On={roles[0][3]?roles[0][3].Create?roles[0][3].Create:false:false}
                                    ref={inst => {PupilMyContractsCreate = inst;}}
                                    referenc={this} /></td>
                                  <td id={3}><Switcher
                                    Id={"PupilMyContractsEdit"}
                                    On={roles[0][3]?roles[0][3].Edit?roles[0][3].Edit:false:false}
                                    ref={inst => {PupilMyContractsEdit = inst;}}
                                    referenc={this} /></td>
                                  <td id={4}><Switcher
                                    Id={"PupilMyContractsDelete"}
                                    On={roles[0][3]?roles[0][3].Delete?roles[0][3].Delete:false:false}
                                    ref={inst => {PupilMyContractsDelete = inst;}}
                                    referenc={this} /></td>
                                </tr>
                                <tr
                                  id={5}
                                  title={"alleKonten"}>
                                  <td style={{ paddingTop: "20px" }}>{Vas.Resources.Labels["AllAccounts"]}</td>
                                  <td id={1}><Switcher
                                    Id={"PupilAccountsRead"}
                                    On={roles[0][4]?roles[0][4].Read?roles[0][4].Read:false:false}
                                    ref={inst => {PupilAccountsRead = inst;}}
                                    referenc={this} /></td>
                                  <td id={2}><Switcher
                                    Id={"PupilAccountsCreate"}
                                    On={roles[0][4]?roles[0][4].Create?roles[0][4].Create:false:false}
                                    ref={inst => {PupilAccountsCreate = inst;}}
                                    referenc={this} /></td>
                                  <td id={3}><Switcher
                                    Id={"PupilAccountsEdit"}
                                    On={roles[0][4]?roles[0][4].Edit?roles[0][4].Edit:false:false}
                                    ref={inst => {PupilAccountsEdit = inst;}}
                                    referenc={this} /></td>
                                  <td id={4}><Switcher
                                    Id={"PupilAccountsDelete"}
                                    On={roles[0][4]?roles[0][4].Delete?roles[0][4].Delete:false:false}
                                    ref={inst => {PupilAccountsDelete = inst;}}
                                    referenc={this} /></td>
                                </tr>
                                <tr
                                  id={6}
                                  title={"meinKonto"}>
                                  <td style={{ paddingTop: "20px" }}>{Vas.Resources.Labels["MyAccount"]}</td>
                                  <td id={1}><Switcher
                                    Id={"PupilMyAccountRead"}
                                    On={roles[0][5]?roles[0][5].Read?roles[0][5].Read:false:false}
                                    ref={inst => {PupilMyAccountRead = inst;}}
                                    referenc={this} /></td>
                                  <td id={2}><Switcher
                                    Id={"PupilMyAccountCreate"}
                                    On={roles[0][5]?roles[0][5].Create?roles[0][5].Create:false:false}
                                    ref={inst => {PupilMyAccountCreate = inst;}}
                                    referenc={this} /></td>
                                  <td id={3}><Switcher
                                    Id={"PupilMyAccountEdit"}
                                    On={roles[0][5]?roles[0][5].Edit?roles[0][5].Edit:false:false}
                                    ref={inst => {PupilMyAccountEdit = inst;}}
                                    referenc={this} /></td>
                                  <td id={4}><Switcher
                                    Id={"PupilMyAccountDelete"}
                                    On={roles[0][5]?roles[0][5].Delete?roles[0][5].Delete:false:false}
                                    ref={inst => {PupilMyAccountDelete = inst;}}
                                    referenc={this} /></td>
                                </tr>
                                <tr
                                  id={7}
                                  title={"Formulare"}>
                                  <td style={{ paddingTop: "20px" }}>{Vas.Resources.Labels["Forms"]}</td>
                                  <td id={1}><Switcher
                                    Id={"PupilFormsRead"}
                                    On={roles[0][6]?roles[0][6].Read?roles[0][6].Read:false:false}
                                    ref={inst => {PupilFormsRead = inst;}}
                                    referenc={this} /></td>
                                  <td id={2}><Switcher
                                    Id={"PupilFormsCreate"}
                                    On={roles[0][6]?roles[0][6].Create?roles[0][6].Create:false:false}
                                    ref={inst => {PupilFormsCreate = inst;}}
                                    referenc={this} /></td>
                                  <td id={3}><Switcher
                                    Id={"PupilFormsEdit"}
                                    On={roles[0][6]?roles[0][6].Edit?roles[0][6].Edit:false:false}
                                    ref={inst => {PupilFormsEdit = inst;}}
                                    referenc={this} /></td>
                                  <td id={4}><Switcher
                                    Id={"PupilFormsDelete"}
                                    On={roles[0][6]?roles[0][6].Delete?roles[0][6].Delete:false:false}
                                    ref={inst => {PupilFormsDelete = inst;}}
                                    referenc={this} /></td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                                } />
                    </td>
                  </tr>
                  {/*<tr>
                    <td>
                      <Panel
                        AppURL={Vas.ApplicationUrl}
                        C={'c2'}
                        HeaderIcon={"Settings"}
                        Width={600}
                        Height={'auto'}
                        Header={Vas.Resources.Labels["School"]}
                        Drag={false}
                        Content={
                          <div>
                            <table>
                              <thead>
                                <tr>
                                  <td style={{ "width":'100%' }}></td><td>{Vas.Resources.Labels["Read"]}</td><td>{Vas.Resources.Labels["Create"]}</td><td>{Vas.Resources.Labels["Edit"]}</td><td>{Vas.Resources.Labels["Delete"]}</td>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  id={1}
                                  title={"alleKunden"}>
                                  <td style={{ paddingTop: "20px" }}>{Vas.Resources.Labels["AllCustomers"]}</td>
                                  <td id={1}><Switcher
                                    Id={"OfficeWorkerCustomersRead"}
                                    On={roles[1][0]?roles[1][0].Read:false}
                                    ref={"OfficeWorkerCustomersRead"}
                                    referenc={this} /></td>
                                  <td id={2}><Switcher
                                    Id={"OfficeWorkerCustomersCreate"}
                                    On={roles[1][0]?roles[1][0].Create:false}
                                    ref={"OfficeWorkerCustomersCreate"}
                                    referenc={this} /></td>
                                  <td id={3}><Switcher
                                    Id={"OfficeWorkerCustomersEdit"}
                                    On={roles[1][0]?roles[1][0].Edit:false}
                                    ref={"OfficeWorkerCustomersEdit"}
                                    referenc={this} /></td>
                                  <td id={4}><Switcher
                                    Id={"OfficeWorkerCustomersDelete"}
                                    On={roles[1][0]?roles[1][0].Delete:false}
                                    ref={"OfficeWorkerCustomersDelete"}
                                    referenc={this} /></td>
                                </tr>
                                <tr
                                  id={2}
                                  title={"meineDaten"}>
                                  <td style={{ paddingTop: "20px" }}>{Vas.Resources.Labels["MyData"]}</td>
                                  <td id={1}><Switcher
                                    Id={"OfficeWorkerMyDataRead"}
                                    On={roles[1][1]?roles[1][1].Read:false}
                                    ref={"OfficeWorkerMyDataRead"}
                                    referenc={this} /></td>
                                  <td id={2}><Switcher
                                    Id={"OfficeWorkerMyDataCreate"}
                                    On={roles[1][1]?roles[1][1].Create:false}
                                    ref={"OfficeWorkerMyDataCreate"}
                                    referenc={this} /></td>
                                  <td id={3}><Switcher
                                    Id={"OfficeWorkerMyDataEdit"}
                                    On={roles[1][1]?roles[1][1].Edit:false}
                                    ref={"OfficeWorkerMyDataEdit"}
                                    referenc={this} /></td>
                                  <td id={4}><Switcher
                                    Id={"OfficeWorkerMyDataDelete"}
                                    On={roles[1][1]?roles[1][1].Delete:false}
                                    ref={"OfficeWorkerMyDataDelete"}
                                    referenc={this} /></td>
                                </tr>
                                <tr
                                  id={3}
                                  title={"alleVerträge"}>
                                  <td style={{ paddingTop: "20px" }}>{Vas.Resources.Labels["AllContracts"]}</td>
                                  <td id={1}><Switcher
                                    Id={"OfficeWorkerContractsRead"}
                                    On={roles[1][2]?roles[1][2].Read:false}
                                    ref={"OfficeWorkerContractsRead"}
                                    referenc={this} /></td>
                                  <td id={2}><Switcher
                                    Id={"OfficeWorkerContractsCreate"}
                                    On={roles[1][2]?roles[1][2].Create:false}
                                    ref={"OfficeWorkerContractsCreate"}
                                    referenc={this} /></td>
                                  <td id={3}><Switcher
                                    Id={"OfficeWorkerContractsEdit"}
                                    On={roles[1][2]?roles[1][2].Edit:false}
                                    ref={"OfficeWorkerContractsEdit"}
                                    referenc={this} /></td>
                                  <td id={4}><Switcher
                                    Id={"OfficeWorkerContractsDelete"}
                                    On={roles[1][2]?roles[1][2].Delete:false}
                                    ref={"OfficeWorkerContractsDelete"}
                                    referenc={this} /></td>
                                </tr>
                                <tr
                                  id={4}
                                  title={"meineVerträge"}>
                                  <td style={{ paddingTop: "20px" }}>{Vas.Resources.Labels["MyContracts"]}</td>
                                  <td id={1}><Switcher
                                    Id={"OfficeWorkerMyContractsRead"}
                                    On={roles[1][3]?roles[1][3].Read:false}
                                    ref={"OfficeWorkerMyContractsRead"}
                                    referenc={this} /></td>
                                  <td id={2}><Switcher
                                    Id={"OfficeWorkerMyContractsCreate"}
                                    On={roles[1][3]?roles[1][3].Create:false}
                                    ref={"OfficeWorkerMyContractsCreate"}
                                    referenc={this} /></td>
                                  <td id={3}><Switcher
                                    Id={"OfficeWorkerMyContractsEdit"}
                                    On={roles[1][3]?roles[1][3].Edit:false}
                                    ref={"OfficeWorkerMyContractsEdit"}
                                    referenc={this} /></td>
                                  <td id={4}><Switcher
                                    Id={"OfficeWorkerMyContractsDelete"}
                                    On={roles[1][3]?roles[1][3].Delete:false}
                                    ref={"OfficeWorkerMyContractsDelete"}
                                    referenc={this} /></td>
                                </tr>
                                <tr
                                  id={5}
                                  title={"alleKonten"}>
                                  <td style={{ paddingTop: "20px" }}>{Vas.Resources.Labels["AllAccounts"]}</td>
                                  <td id={1}><Switcher
                                    Id={"OfficeWorkerAccountsRead"}
                                    On={roles[1][4]?roles[1][4].Read:false}
                                    ref={"OfficeWorkerAccountsRead"}
                                    referenc={this} /></td>
                                  <td id={2}><Switcher
                                    Id={"OfficeWorkerAccountsCreate"}
                                    On={roles[1][4]?roles[1][4].Create:false}
                                    ref={"OfficeWorkerAccountsCreate"}
                                    referenc={this} /></td>
                                  <td id={3}><Switcher
                                    Id={"OfficeWorkerAccountsEdit"}
                                    On={roles[1][4]?roles[1][4].Edit:false}
                                    ref={"OfficeWorkerAccountsEdit"}
                                    referenc={this} /></td>
                                  <td id={4}><Switcher
                                    Id={"OfficeWorkerAccountsDelete"}
                                    On={roles[1][4]?roles[1][4].Delete:false}
                                    ref={"OfficeWorkerAccountsDelete"}
                                    referenc={this} /></td>
                                </tr>
                                <tr
                                  id={6}
                                  title={"meinKonto"}>
                                  <td style={{ paddingTop: "20px" }}>{Vas.Resources.Labels["MyAccount"]}</td>
                                  <td id={1}><Switcher
                                    Id={"OfficeWorkerMyAccountRead"}
                                    On={roles[1][5]?roles[1][5].Read:false}
                                    ref={"OfficeWorkerMyAccountRead"}
                                    referenc={this} /></td>
                                  <td id={2}><Switcher
                                    Id={"OfficeWorkerMyAccountCreate"}
                                    On={roles[1][5]?roles[1][5].Create:false}
                                    ref={"OfficeWorkerMyAccountCreate"}
                                    referenc={this} /></td>
                                  <td id={3}><Switcher
                                    Id={"OfficeWorkerMyAccountEdit"}
                                    On={roles[1][5]?roles[1][5].Edit:false}
                                    ref={"OfficeWorkerMyAccountEdit"}
                                    referenc={this} /></td>
                                  <td id={4}><Switcher
                                    Id={"OfficeWorkerMyAccountDelete"}
                                    On={roles[1][5]?roles[1][5].Delete:false}
                                    ref={"OfficeWorkerMyAccountDelete"}
                                    referenc={this} /></td>
                                </tr>
                                <tr
                                  id={7}
                                  title={"Formulare"}>
                                  <td style={{ paddingTop: "20px" }}>{Vas.Resources.Labels["Forms"]}</td>
                                  <td id={1}><Switcher
                                    Id={"OfficeWorkerFormsRead"}
                                    On={roles[1][6]?roles[1][6].Read:false}
                                    ref={"OfficeWorkerFormsRead"}
                                    referenc={this} /></td>
                                  <td id={2}><Switcher
                                    Id={"OfficeWorkerFormsCreate"}
                                    On={roles[1][6]?roles[1][6].Create:false}
                                    ref={"OfficeWorkerFormsCreate"}
                                    referenc={this} /></td>
                                  <td id={3}><Switcher
                                    Id={"OfficeWorkerFormsEdit"}
                                    On={roles[1][6]?roles[1][6].Edit:false}
                                    ref={"OfficeWorkerFormsEdit"}
                                    referenc={this} /></td>
                                  <td id={4}><Switcher
                                    Id={"OfficeWorkerFormsDelete"}
                                    On={roles[1][6]?roles[1][6].Delete:false}
                                    ref={"OfficeWorkerFormsDelete"}
                                    referenc={this} /></td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                                } />
                    </td>    
                  </tr>*/}
                  <tr>
                    <td>
                      <Panel
                        AppURL={Vas.ApplicationUrl}
                        C={'c3'}
                        HeaderIcon={"Settings"}
                        Width={600}
                        Height={'auto'}
                        Header={Vas.Resources.Labels["School"]}
                        Drag={false}
                        Content={
                          <div>
                            <table>
                              <thead>
                                <tr>
                                  <td style={{ "width":'100%' }}></td><td>{Vas.Resources.Labels["Read"]}</td><td>{Vas.Resources.Labels["Create"]}</td><td>{Vas.Resources.Labels["Edit"]}</td><td>{Vas.Resources.Labels["Delete"]}</td>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  id={1}
                                  title={"alleKunden"}>
                                  <td style={{ paddingTop: "20px" }}>{Vas.Resources.Labels["AllCustomers"]}</td>
                                  <td id={1}><Switcher
                                    Id={"SchoolCustomersRead"}
                                    On={roles[2][0]?roles[2][0].Read?roles[2][0].Read:false:false}
                                    ref={inst => {SchoolCustomersRead = inst;}}
                                    referenc={this} /></td>
                                  <td id={2}><Switcher
                                    Id={"SchoolCustomersCreate"}
                                    On={roles[2][0]?roles[2][0].Create?roles[2][0].Create:false:false}
                                    ref={inst => {SchoolCustomersCreate = inst;}}
                                    referenc={this} /></td>
                                  <td id={3}><Switcher
                                    Id={"SchoolCustomersEdit"}
                                    On={roles[2][0]?roles[2][0].Edit?roles[2][0].Edit:false:false}
                                    ref={inst => {SchoolCustomersEdit = inst;}}
                                    referenc={this} /></td>
                                  <td id={4}><Switcher
                                    Id={"SchoolCustomersDelete"}
                                    On={roles[2][0]?roles[2][0].Delete?roles[2][0].Delete:false:false}
                                    ref={inst => {SchoolCustomersDelete = inst;}}
                                    referenc={this} /></td>
                                </tr>
                                <tr
                                  id={2}
                                  title={"meineDaten"}>
                                  <td style={{ paddingTop: "20px" }}>{Vas.Resources.Labels["MyData"]}</td>
                                  <td id={1}><Switcher
                                    Id={"SchoolMyDataRead"}
                                    On={roles[2][1]?roles[2][1].Read?roles[2][1].Read:false:false}
                                    ref={inst => {SchoolMyDataRead = inst;}}
                                    referenc={this} /></td>
                                  <td id={2}><Switcher
                                    Id={"SchoolMyDataCreate"}
                                    On={roles[2][1]?roles[2][1].Create?roles[2][1].Create:false:false}
                                    ref={inst => {SchoolMyDataCreate = inst;}}
                                    referenc={this} /></td>
                                  <td id={3}><Switcher
                                    Id={"SchoolMyDataEdit"}
                                    On={roles[2][1]?roles[2][1].Edit?roles[2][1].Edit:false:false}
                                    ref={inst => {SchoolMyDataEdit = inst;}}
                                    referenc={this} /></td>
                                  <td id={4}><Switcher
                                    Id={"SchoolMyDataDelete"}
                                    On={roles[2][1]?roles[2][1].Delete?roles[2][1].Delete:false:false}
                                    ref={inst => {SchoolMyDataDelete = inst;}}
                                    referenc={this} /></td>
                                </tr>
                                <tr
                                  id={3}
                                  title={"alleVerträge"}>
                                  <td style={{ paddingTop: "20px" }}>{Vas.Resources.Labels["AllContracts"]}</td>
                                  <td id={1}><Switcher
                                    Id={"SchoolContractsRead"}
                                    On={roles[2][2]?roles[2][2].Read?roles[2][2].Read:false:false}
                                    ref={inst => {SchoolContractsRead = inst;}}
                                    referenc={this} /></td>
                                  <td id={2}><Switcher
                                    Id={"SchoolContractsCreate"}
                                    On={roles[2][2]?roles[2][2].Create?roles[2][2].Create:false:false}
                                    ref={inst => {SchoolContractsCreate = inst;}}
                                    referenc={this} /></td>
                                  <td id={3}><Switcher
                                    Id={"SchoolContractsEdit"}
                                    On={roles[2][2]?roles[2][2].Edit?roles[2][2].Edit:false:false}
                                    ref={inst => {SchoolContractsEdit = inst;}}
                                    referenc={this} /></td>
                                  <td id={4}><Switcher
                                    Id={"SchoolContractsDelete"}
                                    On={roles[2][2]?roles[2][2].Delete?roles[2][2].Delete:false:false}
                                    ref={inst => {SchoolContractsDelete = inst;}}
                                    referenc={this} /></td>
                                </tr>
                                <tr
                                  id={4}
                                  title={"meineVerträge"}>
                                  <td style={{ paddingTop: "20px" }}>{Vas.Resources.Labels["MyContracts"]}</td>
                                  <td id={1}><Switcher
                                    Id={"SchoolMyContractsRead"}
                                    On={roles[2][3]?roles[2][3].Read?roles[2][3].Read:false:false}
                                    ref={inst => {SchoolMyContractsRead = inst;}}
                                    referenc={this} /></td>
                                  <td id={2}><Switcher
                                    Id={"SchoolMyContractsCreate"}
                                    On={roles[2][3]?roles[2][3].Create?roles[2][3].Create:false:false}
                                    ref={inst => {SchoolMyContractsCreate = inst;}}
                                    referenc={this} /></td>
                                  <td id={3}><Switcher
                                    Id={"SchoolMyContractsEdit"}
                                    On={roles[2][3]?roles[2][3].Edit?roles[2][3].Edit:false:false}
                                    ref={inst => {SchoolMyContractsEdit = inst;}}
                                    referenc={this} /></td>
                                  <td id={4}><Switcher
                                    Id={"SchoolMyContractsDelete"}
                                    On={roles[2][3]?roles[2][3].Delete?roles[2][3].Delete:false:false}
                                    ref={inst => {SchoolMyContractsDelete = inst;}}
                                    referenc={this} /></td>
                                </tr>
                                <tr
                                  id={5}
                                  title={"alleKonten"}>
                                  <td style={{ paddingTop: "20px" }}>{Vas.Resources.Labels["AllAccounts"]}</td>
                                  <td id={1}><Switcher
                                    Id={"SchoolAccountsRead"}
                                    On={roles[2][4]?roles[2][4].Read?roles[2][4].Read:false:false}
                                    ref={inst => {SchoolAccountsRead = inst;}}
                                    referenc={this} /></td>
                                  <td id={2}><Switcher
                                    Id={"SchoolAccountsCreate"}
                                    On={roles[2][4]?roles[2][4].Create?roles[2][4].Create:false:false}
                                    ref={inst => {SchoolAccountsCreate = inst;}}
                                    referenc={this} /></td>
                                  <td id={3}><Switcher
                                    Id={"SchoolAccountsEdit"}
                                    On={roles[2][4]?roles[2][4].Edit?roles[2][4].Edit:false:false}
                                    ref={inst => {SchoolAccountsEdit = inst;}}
                                    referenc={this} /></td>
                                  <td id={4}><Switcher
                                    Id={"SchoolAccountsDelete"}
                                    On={roles[2][4]?roles[2][4].Delete?roles[2][4].Delete:false:false}
                                    ref={inst => {SchoolAccountsDelete = inst;}}
                                    referenc={this} /></td>
                                </tr>
                                <tr
                                  id={6}
                                  title={"meinKonto"}>
                                  <td style={{ paddingTop: "20px" }}>{Vas.Resources.Labels["MyAccount"]}</td>
                                  <td id={1}><Switcher
                                    Id={"SchoolMyAccountRead"}
                                    On={roles[2][5]?roles[2][5].Read?roles[2][5].Read:false:false}
                                    ref={inst => {SchoolMyAccountRead = inst;}}
                                    referenc={this} /></td>
                                  <td id={2}><Switcher
                                    Id={"SchoolMyAccountCreate"}
                                    On={roles[2][5]?roles[2][5].Create?roles[2][5].Create:false:false}
                                    ref={inst => {SchoolMyAccountCreate = inst;}}
                                    referenc={this} /></td>
                                  <td id={3}><Switcher
                                    Id={"SchoolMyAccountEdit"}
                                    On={roles[2][5]?roles[2][5].Edit?roles[2][5].Edit:false:false}
                                    ref={inst => {SchoolMyAccountEdit = inst;}}
                                    referenc={this} /></td>
                                  <td id={4}><Switcher
                                    Id={"SchoolMyAccountDelete"}
                                    On={roles[2][5]?roles[2][5].Delete?roles[2][5].Delete:false:false}
                                    ref={inst => {SchoolMyAccountDelete = inst;}}
                                    referenc={this} /></td>
                                </tr>
                                <tr
                                  id={7}
                                  title={"Formulare"}>
                                  <td style={{ paddingTop: "20px" }}>{Vas.Resources.Labels["Forms"]}</td>
                                  <td id={1}><Switcher
                                    Id={"SchoolFormsRead"}
                                    On={roles[2][6]?roles[2][6].Read?roles[2][6].Read:false:false}
                                    ref={inst => {SchoolFormsRead = inst;}}
                                    referenc={this} /></td>
                                  <td id={2}><Switcher
                                    Id={"SchoolFormsCreate"}
                                    On={roles[2][6]?roles[2][6].Create?roles[2][6].Create:false:false}
                                    ref={inst => {SchoolFormsCreate = inst;}}
                                    referenc={this} /></td>
                                  <td id={3}><Switcher
                                    Id={"SchoolFormsEdit"}
                                    On={roles[2][6]?roles[2][6].Edit?roles[2][6].Edit:false:false}
                                    ref={inst => {SchoolFormsEdit = inst;}}
                                    referenc={this} /></td>
                                  <td id={4}><Switcher
                                    Id={"SchoolFormsDelete"}
                                    On={roles[2][6]?roles[2][6].Delete?roles[2][6].Delete:false:false}
                                    ref={inst => {SchoolFormsDelete = inst;}}
                                    referenc={this} /></td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        } />
                    </td>
                  </tr>
                </tbody>
              </table>

              ,document.getElementById('RoleFields')
            );
            this.setState({},()=>{
              this.setState({
                PupilFields:[PupilCustomersRead,PupilCustomersCreate,PupilCustomersEdit,PupilCustomersDelete,
                  PupilMyDataRead,PupilMyDataCreate,PupilMyDataEdit,PupilMyDataDelete,
                  PupilContractsRead,PupilContractsCreate,PupilContractsEdit,PupilContractsDelete,
                  PupilMyContractsRead,PupilMyContractsCreate,PupilMyContractsEdit,PupilMyContractsDelete,
                  PupilAccountsRead,PupilAccountsCreate,PupilAccountsEdit,PupilAccountsDelete,
                  PupilMyAccountRead,PupilMyAccountCreate,PupilMyAccountEdit,PupilMyAccountDelete,
                  PupilFormsRead,PupilFormsCreate,PupilFormsEdit,PupilFormsDelete
                  ]/*,
                  OfficeWorkerFields:[this.refs.OfficeWorkerCustomersRead,this.refs.OfficeWorkerCustomersCreate,this.refs.OfficeWorkerCustomersEdit,this.refs.OfficeWorkerCustomersDelete,
                              this.refs.OfficeWorkerMyDataRead,this.refs.OfficeWorkerMyDataCreate,this.refs.OfficeWorkerMyDataEdit,this.refs.OfficeWorkerMyDataDelete,
                              this.refs.OfficeWorkerContractsRead,this.refs.OfficeWorkerContractsCreate,this.refs.OfficeWorkerContractsEdit,this.refs.OfficeWorkerContractsDelete,
                              this.refs.OfficeWorkerMyContractsRead,this.refs.OfficeWorkerMyContractsCreate,this.refs.OfficeWorkerMyContractsEdit,this.refs.OfficeWorkerMyContractsDelete,
                              this.refs.OfficeWorkerAccountsRead,this.refs.OfficeWorkerAccountsCreate,this.refs.OfficeWorkerAccountsEdit,this.refs.OfficeWorkerAccountsDelete,
                              this.refs.OfficeWorkerMyAccountRead,this.refs.OfficeWorkerMyAccountCreate,this.refs.OfficeWorkerMyAccountEdit,this.refs.OfficeWorkerMyAccountDelete,
                              this.refs.OfficeWorkerFormsRead,this.refs.OfficeWorkerFormsCreate,this.refs.OfficeWorkerFormsEdit,this.refs.OfficeWorkerFormsDelete
                  ]*/,
                  SchoolFields:[SchoolCustomersRead,SchoolCustomersCreate,SchoolCustomersEdit,SchoolCustomersDelete,
                      SchoolMyDataRead,SchoolMyDataCreate,SchoolMyDataEdit,SchoolMyDataDelete,
                      SchoolContractsRead,SchoolContractsCreate,SchoolContractsEdit,SchoolContractsDelete,
                      SchoolMyContractsRead,SchoolMyContractsCreate,SchoolMyContractsEdit,SchoolMyContractsDelete,
                      SchoolAccountsRead,SchoolAccountsCreate,SchoolAccountsEdit,SchoolAccountsDelete,
                      SchoolMyAccountRead,SchoolMyAccountCreate,SchoolMyAccountEdit,SchoolMyAccountDelete,
                      SchoolFormsRead,SchoolFormsCreate,SchoolFormsEdit,SchoolFormsDelete
                  ]
              });
              ReactDOM.unmountComponentAtNode(document.getElementById('popupContainer'));
            });
        }
        else if( observer === "UpdateRoleConfiguration"){
          ReactDOM.render(<MessageBox 
            AppURL={Vas.ApplicationUrl} 
            Title={Vas.Resources.Titles["Change"]} 
            Message={Vas.Resources.Labels["RoleChangeSuccess"]} 
            Click={()=>{window.location = "/roleManagement";}} /> 
              , document.getElementById('messageContainer'));
          ReactDOM.unmountComponentAtNode(document.getElementById('popupContainer'));
        }
      });
    }

    Change(){
        ReactDOM.render(<Loading modal={true} />,document.getElementById('popupContainer'));
        let pupilArr =[];
        //let officeWorkerArr =[];
        let schoolArr =[];
        let rowId = 0;
        
        let className = '';
        let read = '';
        let create = '';
        let edit = '';
        let del = '';

        this.state.PupilFields.forEach(e => {
            let id = document.getElementById(e.props.Id).parentElement.parentElement.parentElement.parentElement.parentElement.id;
            if ( id !== rowId){//neue Zeile
                className = document.getElementById(e.props.Id).parentElement.parentElement.parentElement.parentElement.parentElement.title;
                rowId = id;
                read = document.getElementById(e.props.Id).checked;
                //read = e.state.on;
            } else {
                switch (document.getElementById(e.props.Id).parentElement.parentElement.parentElement.parentElement.id){
                    case '2':
                        //create = e.state.on;
                        create = document.getElementById(e.props.Id).checked;
                        break;
                    case '3':
                        //edit = e.state.on;
                        edit = document.getElementById(e.props.Id).checked;
                        break;
                    case '4':
                        //del = e.state.on;
                        del = document.getElementById(e.props.Id).checked;
                        pupilArr.push([className,read,create,edit,del]);
                        break;
                    default:break;
                }
            }
        });
        
        /*this.state.OfficeWorkerFields.forEach(e => {
                
            let id = document.getElementById(e.props.Id).parentElement.parentElement.parentElement.parentElement.parentElement.id;
            
            if ( id !== rowId){//neue Zeile
                className = document.getElementById(e.props.Id).parentElement.parentElement.parentElement.parentElement.parentElement.title;
                rowId = id;
                read = e.state.on;
            } else {
                switch (document.getElementById(e.props.Id).parentElement.parentElement.parentElement.parentElement.id){
                    case '2':
                        create = e.state.on;
                        break;
                    case '3':
                        edit = e.state.on;
                        break;
                    case '4':
                        del = e.state.on;
                        officeWorkerArr.push([className,read,create,edit,del]);
                        break;
                    default:break;
                }
            }
        });*/

        this.state.SchoolFields.forEach(e => {
                
            let id = document.getElementById(e.props.Id).parentElement.parentElement.parentElement.parentElement.parentElement.id;
            
            if ( id !== rowId){//neue Zeile
                className = document.getElementById(e.props.Id).parentElement.parentElement.parentElement.parentElement.parentElement.title;
                rowId = id;
                //read = e.state.on;
                read = document.getElementById(e.props.Id).checked;
            } else {
                switch (document.getElementById(e.props.Id).parentElement.parentElement.parentElement.parentElement.id){
                    case '2':
                        //create = e.state.on;
                        create = document.getElementById(e.props.Id).checked;
                        break;
                    case '3':
                        //edit = e.state.on;
                        edit = document.getElementById(e.props.Id).checked;
                        break;
                    case '4':
                        //del = e.state.on;
                        del = document.getElementById(e.props.Id).checked;
                        schoolArr.push([className,read,create,edit,del]);
                        break;
                    default:break;
                }
            }
        });
        
        let rights1 = [];
        pupilArr.forEach(e => {
            let right = new Right(e[0],e[1],e[2],e[3],e[4]);
            rights1.push(right.getRight());
        });
        
        /*let rights2 =[];
        officeWorkerArr.forEach(e=>{
            let right = new Right(e[0],e[1],e[2],e[3],e[4]);
            rights2.push(right.getRight());
        });*/
        
        let rights3 = [];
        schoolArr.forEach(e => {
            let right = new Right(e[0],e[1],e[2],e[3],e[4]);
            rights3.push(right.getRight());
        });
        
        let right30 = new Right("alleKunden",false,false,false,false);
        let right31 = new Right("meineDaten",false,false,false,false);
        let right32 = new Right("alleVerträge",false,false,false,false);
        let right33 = new Right("meineVerträge",false,false,false,false);
        let right34 = new Right("alleKonten",false,false,false,false);
        let right35 = new Right("meinKonto",false,false,false,false);
        let right36 = new Right("Formulare",false,false,false,false);
        let rights2 = [right30,right31,right32,right33,right34,right35,right36];

        let right = new Right("alleKunden",true,true,true,true);
        let right1 = new Right("meineDaten",true,true,true,true);
        let right2 = new Right("alleVerträge",true,true,true,true);
        let right3 = new Right("meineVerträge",true,true,true,true);
        let right4 = new Right("alleKonten",true,true,true,true);
        let right5 = new Right("meinKonto",true,true,true,true);
        let right6 = new Right("Formulare",true,true,true,true);
        let rights4 = [right,right1,right2,right3,right4,right5,right6];
        
        //localStorage.setItem("vas_roleConfig",JSON.stringify(rights4));

        let rights =[[rights1,1],[rights2,2],[rights3,3],[rights4,99]];
        for (let i = 0; i< rights.length; i++){
            this.Request.setErrorHandler(()=>{
              ReactDOM.render(<MessageBox 
                AppURL={Vas.ApplicationUrl} 
                Title={Vas.Resources.Titles["Change"]} 
                Message={Vas.Resources.Labels["RoleChangeNoSuccess"]} 
                Click={()=>{window.location = "/roleManagement";}} /> 
                  , document.getElementById('messageContainer'));
              ReactDOM.unmountComponentAtNode(document.getElementById('popupContainer'));
            });

            this.RoleConfig.UpdateRoleConfiguration(rights[i][0],rights[i][1]);
        }        
    }

    Switch(id){
      if (document.getElementById(id)){
        let colId = parseInt(document.getElementById(id).parentElement.parentElement.parentElement.parentElement.id,10);
        
        if (colId === 1){//Lesen
          if(document.getElementById(id).checked === false){//wenn Lesen = false gesetzt wird, werden alle Schreibrechte (außer Anlegen) auch auf false gesetzt
            for (let i = 3; i <= 4; i++){
              let newId = document.getElementById(id).parentElement.parentElement.parentElement.parentElement.parentElement.children[i].children[0].children[0].children[0].children[0].id;
              if(document.getElementById(newId).checked === true){
                document.getElementById(newId).checked = false;
              }
            }
          }  
        } else if (colId > 2){//Bearbeiten, Entfernen
          if(document.getElementById(id).checked === true){//wenn Bearbeiten, Entfernen auf true gesetzt wird, Lesen auch auf true gesetzt
            for (let i = 3; i <= 4; i++){
              let newId = document.getElementById(id).parentElement.parentElement.parentElement.parentElement.parentElement.children[1].children[0].children[0].children[0].children[0].id;
              if(document.getElementById(newId).checked === false){
                document.getElementById(newId).checked = true;
              }
            }
          }  
        }
      }
    }

    render()
    {  
        return (<div className={"form"}>
          <div id={"RoleFields"}></div>
          <p />
          <ExtendedButton
            Text={Vas.Resources.Labels["Change"]}
            Float={"left"}
            Width={170}
            Usable={true}
            OnClick={()=>{this.Change();}} />
        </div>);
    }
}
export default RoleManagement;
